<div class="container">

  <section class='header'>
    <mat-toolbar color='secondary' fxLayoutAlign="space-between">
      <div class='header-title'>

        <mat-icon>people_outline</mat-icon>

        <div style='margin: -4px 0 0 10px'>
          {{ local_title }}

          <span *ngIf="isAnnuityFree && calcFinish"> - Isento</span>
          <span *ngIf="!isAnnuityFree && totalPlots === 0 && calcFinish"> - Quite</span>
          <span *ngIf="calcFinish && !isAnnuityFree && totalPlots !== 0"> - {{totalPlots}} anuidade em aberto, débito =
            {{ totalDebit | currency:'BRL':'':'1.2-2' }}</span>

        </div>

      </div>

      <button class="button-close" mat-raised-button mat-dialog-close>
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar>
  </section>

  <mat-tab-group>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class='tab-icon'>tag_faces</mat-icon>
        <div>Cadastro</div>
      </ng-template>


      <div class='content-register'>

        <mat-card>

          <div style="display: flex; flex-direction: row; justify-content: space-between;">

            <div>
              <div>
                <mat-form-field class="name-width" appearance="outline">
                  <mat-label>Nome </mat-label>
                  <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="memberForm.controls.name"
                    autocomplete="off">
                </mat-form-field>

                <mat-form-field class="gender-width" appearance="outline">
                  <mat-label>Gênero</mat-label>
                  <mat-select [errorStateMatcher]="matcher" [formControl]="memberForm.controls.sex">
                    <mat-option value="M">M</mat-option>
                    <mat-option value="F">F</mat-option>
                  </mat-select>
                </mat-form-field>

              </div>

              <mat-form-field class="short-name-width" appearance="outline">
                <mat-label>Nome no crachá</mat-label>
                <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="memberForm.controls.shortName"
                  autocomplete="off">
              </mat-form-field>

              <div>

                <mat-checkbox class="staff-width" color='primary' [formControl]="memberForm.controls.staff">
                  <span>Staff</span>
                </mat-checkbox>

                <mat-checkbox class="tester-width" color='primary' [formControl]="memberForm.controls.tester">
                  <span>Tester</span>
                </mat-checkbox>

                <mat-checkbox class="tester-width" color='primary' [formControl]="memberForm.controls.foreignCustomer">
                  <span>Estrangeiro</span>
                </mat-checkbox>

              </div>

              <div style="margin-top: 40px;">

                <mat-form-field *ngIf="subCategories" class="category-width" appearance="outline">
                  <mat-label>Categoria </mat-label>
                  <mat-select [errorStateMatcher]="matcher" [ngModel]='subCategorySelected_id'
                    (ngModelChange)='onSubCategoryChange($event)'>
                    <mat-option *ngFor="let subcat of subCategories" [value]="subcat.id">
                      {{subcat.name }}
                    </mat-option>
                  </mat-select>

                </mat-form-field>

                <!--
                <div>
                  <span>{{ partnerText }}</span>
                  <span *ngIf='oldCategory'>
                    - Antes: {{oldCategory.name}}
                  </span>
                </div>
-->

              </div>

            </div>

            <div style="display: flex; flex-direction: row; justify-content: flex-end;">
              <div class='img-input'>

                <input #fileMember type="file" accept='image/*' style='display:none;'
                  (change)="_memberService.previewImage($event)" />

                <button mat-raised-button (click)='fileMember.click()'>
                  <mat-icon class='icon-add'>image_search</mat-icon>
                </button>

              </div>

              <div class="member-image">
                <img [src]="_memberService.storedImage" *ngIf="_memberService.storedImage">
              </div>
            </div>

          </div>

        </mat-card>

        <mat-card>

          <div style="display: flex; flex-direction: row; justify-content: flex-start;">

            <mat-form-field class="annuity-from-width" appearance="outline">
              <mat-label>Vigência</mat-label>
              <input matInput type="number" [errorStateMatcher]="matcher"
                [formControl]="memberForm.controls.annuity_from" autocomplete="off">
            </mat-form-field>

            <mat-form-field *ngIf="situations" class="situation-width" appearance="outline">
              <mat-label>Anuidades </mat-label>
              <mat-select [errorStateMatcher]="matcher" [formControl]="memberForm.controls.situation">
                <mat-option *ngFor="let sit of situations" [value]="sit.value">
                  {{ sit.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="balance-width" *ngIf="memberForm.controls.situation.value == '1'"
              appearance="outline">
              <mat-label>Débito</mat-label>
              <input matInput type="number" [errorStateMatcher]="matcher" [formControl]="memberForm.controls.balance"
                autocomplete="off">
            </mat-form-field>

            <mat-form-field class="balance-width" appearance="outline">
              <mat-label>Crédito</mat-label>
              <input matInput type="number" [errorStateMatcher]="matcher" [formControl]="memberForm.controls.credit"
                autocomplete="off">
            </mat-form-field>

          </div>

        </mat-card>

        <mat-card>
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Observações</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="memberForm.controls.obs"
              autocomplete="off">
          </mat-form-field>
        </mat-card>

        <mat-card>
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Notas</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="memberForm.controls.note"
              autocomplete="off">
          </mat-form-field>
        </mat-card>

        <mat-card>

          <div style="display: flex; flex-direction: row; justify-content: flex-start;">

            <mat-form-field class="half-width" appearance="outline">
              <mat-label>Email </mat-label>
              <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="memberForm.controls.email"
                autocomplete="off">
            </mat-form-field>

            <mat-form-field class="half-width" appearance="outline">
              <mat-label>Email 2</mat-label>
              <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="memberForm.controls.email2"
                autocomplete="off">
            </mat-form-field>

          </div>
        </mat-card>

        <mat-card>

          <mat-form-field class="half-width" appearance="outline">
            <mat-label>Código País</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher"
              [formControl]="memberForm.controls.cellPhonePrefix" autocomplete="off">
          </mat-form-field>

          <div>

            <mat-form-field class="half-width" appearance="outline">
              <mat-label>Celular </mat-label>
              <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="memberForm.controls.cellPhone"
                autocomplete="off">
            </mat-form-field>


            <mat-form-field class="half-width" appearance="outline">
              <mat-label>Consultório</mat-label>
              <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="memberForm.controls.clinicPhone"
                autocomplete="off">
            </mat-form-field>

            <mat-form-field class="half-width" appearance="outline">
              <mat-label>Hospital</mat-label>
              <input matInput type="text" [errorStateMatcher]="matcher"
                [formControl]="memberForm.controls.hospitalPhone" autocomplete="off">
            </mat-form-field>

            <mat-form-field class="half-width" appearance="outline">
              <mat-label>Auxiliar</mat-label>
              <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="memberForm.controls.aux1Phone"
                autocomplete="off">
            </mat-form-field>

            <mat-form-field class="half-width" appearance="outline">
              <mat-label>Auxiliar 2</mat-label>
              <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="memberForm.controls.aux2Phone"
                autocomplete="off">
            </mat-form-field>

            <mat-form-field class="half-width" appearance="outline">
              <mat-label>Fax</mat-label>
              <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="memberForm.controls.faxPhone"
                autocomplete="off">
            </mat-form-field>

          </div>

        </mat-card>

        <mat-card>
          <div style="display: flex; flex-direction: row; justify-content: flex-start;">
            <mat-form-field class="doc-width" appearance="outline">
              <mat-label>CPF</mat-label>
              <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="memberForm.controls.cpf"
                autocomplete="off">
            </mat-form-field>

            <mat-form-field class="doc-width" appearance="outline">
              <mat-label>RG</mat-label>
              <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="memberForm.controls.rg"
                autocomplete="off">
            </mat-form-field>

            <mat-form-field class="doc-width" appearance="outline">
              <mat-label>CRM</mat-label>
              <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="memberForm.controls.crm"
                autocomplete="off">
            </mat-form-field>

            <mat-form-field class="doc-width" appearance="outline">
              <mat-label>CRM UF</mat-label>
              <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="memberForm.controls.crmUF"
                autocomplete="off">
            </mat-form-field>

            <mat-form-field class="doc-width" appearance="outline">
              <mat-label>RQE</mat-label>
              <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="memberForm.controls.rqe"
                autocomplete="off">
            </mat-form-field>

          </div>

        </mat-card>

        <mat-card>
          <div style="display: flex; flex-direction: row; justify-content: flex-start;">

            <mat-form-field class="date-width" appearance="outline">
              <mat-label>Nascimento</mat-label>
              <input matInput [matDatepicker]="pickerBirth" [errorStateMatcher]="matcher"
                [formControl]="memberForm.controls.dateBirth">
              <mat-datepicker-toggle matSuffix [for]="pickerBirth"></mat-datepicker-toggle>
              <mat-datepicker #pickerBirth></mat-datepicker>
            </mat-form-field>

            <mat-form-field class="date-width" appearance="outline">
              <mat-label>Filiação</mat-label>
              <input matInput [matDatepicker]="pickerFiliation" [errorStateMatcher]="matcher"
                [formControl]="memberForm.controls.dateFiliation">
              <mat-datepicker-toggle matSuffix [for]="pickerFiliation"></mat-datepicker-toggle>
              <mat-datepicker #pickerFiliation></mat-datepicker>
            </mat-form-field>

            <mat-form-field class="date-width" appearance="outline">
              <mat-label>Titulo</mat-label>
              <input matInput [matDatepicker]="pickerTitle" [errorStateMatcher]="matcher"
                [formControl]="memberForm.controls.dateTitle">
              <mat-datepicker-toggle matSuffix [for]="pickerTitle"></mat-datepicker-toggle>
              <mat-datepicker #pickerTitle></mat-datepicker>
            </mat-form-field>

            <mat-form-field class="date-width" appearance="outline">
              <mat-label>Cadastro</mat-label>
              <input matInput [matDatepicker]="pickerCreated" [errorStateMatcher]="matcher"
                [formControl]="memberForm.controls.created">
              <mat-datepicker-toggle matSuffix [for]="pickerCreated"></mat-datepicker-toggle>
              <mat-datepicker #pickerCreated></mat-datepicker>
            </mat-form-field>

          </div>

        </mat-card>

        <mat-card>

          <div style='display: flex; flex-direction: row;'>
            <mat-form-field class="half-width" appearance="outline">
              <mat-label>CEP</mat-label>
              <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="memberForm.controls.postalCode"
                autocomplete="off">
            </mat-form-field>
            <div>
              <button mat-raised-button (click)='getAddressByPostalCode(memberForm.controls.postalCode.value)'>
                <mat-icon class='icon-add'>find_in_page</mat-icon>
              </button>
            </div>


            <mat-form-field *ngIf="regionals" class="regional-width" appearance="outline">
              <mat-label>Regional</mat-label>
              <mat-select [errorStateMatcher]="matcher" [formControl]="memberForm.controls.regional">
                <mat-option *ngFor="let regional of regionals" [value]="regional.short">
                  {{ regional.short }}
                </mat-option>
              </mat-select>
            </mat-form-field>

          </div>


          <div style='display: flex; flex-direction: row;'>

            <mat-form-field class="address-width" appearance="outline">
              <mat-label>Endereço</mat-label>
              <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="memberForm.controls.address"
                autocomplete="off">
            </mat-form-field>

            <mat-form-field class="numero-width" appearance="outline">
              <mat-label>Número</mat-label>
              <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="memberForm.controls.number"
                autocomplete="off">
            </mat-form-field>

            <mat-form-field class="complemento-width" appearance="outline">
              <mat-label>Complemento</mat-label>
              <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="memberForm.controls.complement"
                autocomplete="off">
            </mat-form-field>

          </div>

          <div style='display: flex; flex-direction: row;'>

            <mat-form-field class="half-width" appearance="outline">
              <mat-label>Bairro</mat-label>
              <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="memberForm.controls.district"
                autocomplete="off">
            </mat-form-field>

            <mat-form-field class="half-width" appearance="outline">
              <mat-label>Cidade</mat-label>
              <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="memberForm.controls.city"
                autocomplete="off">
            </mat-form-field>

          </div>

          <div style='display: flex; flex-direction: row;'>

            <mat-form-field class="half-width" appearance="outline">
              <mat-label>Estado</mat-label>
              <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="memberForm.controls.state"
                autocomplete="off">
            </mat-form-field>

            <!--<mat-form-field class="half-width" appearance="outline">
              <mat-label>País</mat-label>
              <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="memberForm.controls.country"
                autocomplete="off">
            </mat-form-field>
-->

            <mat-form-field class="half-width" appearance="outline">
              <mat-label>Pais</mat-label>
              <mat-select [errorStateMatcher]="matcher" [formControl]="memberForm.controls.country">
                <mat-option *ngFor="let item of countries" [value]="item.country">
                  {{ item.country}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="memberForm.controls.country.hasError('required')">
                Selecione um pais
              </mat-error>
            </mat-form-field>



          </div>

        </mat-card>

        <mat-card>

          <ckeditor [config]="{ 
          toolbar: [ 'heading', '|', 'bold', 'italic', '|', 'bulletedList', 'numberedList' ] }"
            [formControl]="memberForm.controls.text" [editor]="Editor"></ckeditor>
        </mat-card>

        <mat-card *ngIf="isEdit">

          <h4 style="color: rgba(0,0,0, .6)">Formação</h4>

          <mat-table [dataSource]="(memberBackgrounds$ | async) || []" matSort matSortActive="date">

            <ng-container matColumnDef="dateStart">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Início </mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.dateStart | date: 'dd/MM/yyyy'}}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="dateEnd">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Término </mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.dateEnd | date: 'dd/MM/yyyy'}}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="text">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Texto </mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.text }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="location">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Local </mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.location }}
              </mat-cell>
            </ng-container>


            <ng-container matColumnDef="edit">
              <mat-header-cell *matHeaderCellDef>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <a mat-button (click)='openMemberBackgroundDialog(element)' style='background-color: whitesmoke;'>
                  <mat-icon class='icon-info' style='font-size:1.5em;'>
                    info_outline
                  </mat-icon>
                </a>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="delete">
              <mat-header-cell *matHeaderCellDef>
                <div style='width:60px;'>
                  <a mat-button (click)="openMemberBackgroundDialog(null)">
                    <mat-icon color='primary'>add_circle_outline</mat-icon>
                  </a>
                </div>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">


                <a mat-button (click)='deleteMemberBackground(element)' style='background-color: whitesmoke;'>
                  <mat-icon class='icon-delete' style='font-size:1.5em;'>delete_outline
                  </mat-icon>
                </a>

              </mat-cell>
            </ng-container>

            <mat-header-row class='mat-header-row' *matHeaderRowDef="displayedMemberBackgroundColumns">
            </mat-header-row>

            <mat-row *matRowDef="let row; columns: displayedMemberBackgroundColumns;">
            </mat-row>

          </mat-table>
        </mat-card>

        <mat-card *ngIf="isEdit">

          <h4 style="color: rgba(0,0,0, .6)">TPI/CCV</h4>
          <mat-table [dataSource]="(memberTpiccv$ | async) || []" matSort matSortActive="date">

            <ng-container matColumnDef="date">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Data </mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.date | date: 'dd/MM/yyyy'}}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="text">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Texto </mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.text }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="edit">
              <mat-header-cell *matHeaderCellDef>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <a mat-button (click)='openMemberTpiccvDialog(element)' style='background-color: whitesmoke;'>
                  <mat-icon class='icon-info' style='font-size:1.5em;'>
                    info_outline
                  </mat-icon>
                </a>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="delete">
              <mat-header-cell *matHeaderCellDef>
                <div style='width:60px;'>
                  <a mat-button (click)="openMemberTpiccvDialog(null)">
                    <mat-icon color='primary'>add_circle_outline</mat-icon>
                  </a>
                </div>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">


                <a mat-button (click)='deleteMemberTpiccv(element)' style='background-color: whitesmoke;'>
                  <mat-icon class='icon-delete' style='font-size:1.5em;'>delete_outline
                  </mat-icon>
                </a>

              </mat-cell>
            </ng-container>

            <mat-header-row class='mat-header-row' *matHeaderRowDef="displayedMemberTpiccvColumns">
            </mat-header-row>

            <mat-row *matRowDef="let row; columns: displayedMemberTpiccvColumns;">
            </mat-row>

          </mat-table>
        </mat-card>

        <mat-card *ngIf="isEdit">

          <h4 style="color: rgba(0,0,0, .6)">Links</h4>
          <mat-table [dataSource]="(memberLinks$ | async) || []" matSort matSortActive="date">

            <ng-container matColumnDef="date">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Data </mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.date | date: 'dd/MM/yyyy'}}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="text">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Texto </mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.text }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="link">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Link </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <a mat-button (click)="goToMemberLink(element.link)">
                  <span style="color: blue;"> {{ element.link }} </span>
                </a>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="edit">
              <mat-header-cell *matHeaderCellDef>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <a mat-button (click)='openMemberLinksDialog(element)' style='background-color: whitesmoke;'>
                  <mat-icon class='icon-info' style='font-size:1.5em;'>
                    info_outline
                  </mat-icon>
                </a>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="delete">
              <mat-header-cell *matHeaderCellDef>
                <div style='width:60px;'>
                  <a mat-button (click)="openMemberLinksDialog(null)">
                    <mat-icon color='primary'>add_circle_outline</mat-icon>
                  </a>
                </div>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">


                <a mat-button (click)='deleteMemberLink(element)' style='background-color: whitesmoke;'>
                  <mat-icon class='icon-delete' style='font-size:1.5em;'>delete_outline
                  </mat-icon>
                </a>

              </mat-cell>
            </ng-container>

            <mat-header-row class='mat-header-row' *matHeaderRowDef="displayedMemberLinkColumns">
            </mat-header-row>

            <mat-row *matRowDef="let row; columns: displayedMemberLinkColumns;">
            </mat-row>

          </mat-table>
        </mat-card>

        <mat-card *ngIf="isEdit">

          <h4 style="color: rgba(0,0,0, .6)">Anotações</h4>

          <mat-table [dataSource]="(memberAnnotations$ | async) || []" matSort matSortActive="date">

            <ng-container matColumnDef="date">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Data </mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.date | date: 'dd/MM/yyyy'}}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="text">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Texto </mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.text }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="status">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Status </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <span *ngIf='element.status === 0'>
                  <img src='/assets/images/status/img_silver.png'>
                </span>
                <span *ngIf='element.status === 1'>
                  <img src='/assets/images/status/img_red.png'>
                </span>
                <span *ngIf='element.status === 2'>
                  <img src='/assets/images/status/img_green.png'>
                </span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="edit">
              <mat-header-cell *matHeaderCellDef>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <a mat-button (click)='openAnnotationDialog(element)' style='background-color: whitesmoke;'>
                  <mat-icon class='icon-info' style='font-size:1.5em;'>
                    info_outline
                  </mat-icon>
                </a>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="delete">
              <mat-header-cell *matHeaderCellDef>
                <div style='width:60px;'>
                  <a mat-button (click)="openAnnotationDialog(null)">
                    <mat-icon color='primary'>add_circle_outline</mat-icon>
                  </a>
                </div>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">


                <a mat-button (click)='deleteAnnotation(element)' style='background-color: whitesmoke;'>
                  <mat-icon class='icon-delete' style='font-size:1.5em;'>delete_outline
                  </mat-icon>
                </a>

              </mat-cell>
            </ng-container>

            <mat-header-row class='mat-header-row' *matHeaderRowDef="displayedAnnotationColumns">
            </mat-header-row>

            <mat-row *matRowDef="let row; columns: displayedAnnotationColumns;">
            </mat-row>

          </mat-table>
        </mat-card>

        <mat-card *ngIf="isEdit">
          <h4 style="color: rgba(0,0,0, .6)">Categorias</h4>

          <mat-table [dataSource]="(memberSubCategoryHistory$ | async) || []" matSort matSortActive="date">

            <ng-container matColumnDef="date">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Data </mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.date | date: 'dd/MM/yyyy'}}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="subcategory">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Categoria </mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.subcategory_name }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="payannuity">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Anuidade </mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.subcategory_annuity }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="edit">
              <mat-header-cell *matHeaderCellDef>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <a mat-button (click)='openSubcategoryHistoryDialog(element)' style='background-color: whitesmoke;'>
                  <mat-icon class='icon-info' style='font-size:1.5em;'>
                    info_outline
                  </mat-icon>
                </a>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="delete">
              <mat-header-cell *matHeaderCellDef>
                <div style='width:60px;'>
                  <a mat-button (click)="openSubcategoryHistoryDialog(null)">
                    <mat-icon color='primary'>add_circle_outline</mat-icon>
                  </a>
                </div>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">

                <a mat-button (click)='deleteSubcategoryHistory(element)' style='background-color: whitesmoke;'>
                  <mat-icon class='icon-delete' style='font-size:1.5em;'>delete_outline
                  </mat-icon>
                </a>

              </mat-cell>
            </ng-container>

            <mat-header-row class='mat-header-row' *matHeaderRowDef="displayedSubcategoryHistoryColumns">
            </mat-header-row>

            <mat-row *matRowDef="let row; columns: displayedSubcategoryHistoryColumns;">
            </mat-row>

          </mat-table>
          ri
        </mat-card>

      </div>


      <div class="actions" fxLayoutAlign="flex-end" flex *ngIf="!isEdit">
        <button mat-raised-button (click)='insert()' [disabled]="memberForm.invalid" *ngIf="!isEdit">
          <mat-icon class='icon-done'>check_circle_outline</mat-icon>
        </button>
      </div>

      <div class="actions" fxLayoutAlign="space-between" flex *ngIf="isEdit">

        <button style='margin:0;' mat-raised-button (click)='deleteMember()'>
          <mat-icon class='icon-delete'>delete_outline</mat-icon>
        </button>

        <div>
          <button mat-raised-button (click)='update()' [disabled]="memberForm.invalid" *ngIf="isEdit">
            <mat-icon class='icon-done'>check_circle_outline</mat-icon>
          </button>
        </div>

      </div>

    </mat-tab>

    <mat-tab *ngIf="isEdit">
      <ng-template mat-tab-label>
        <mat-icon class='tab-icon'>post_add</mat-icon>
        <div>Documentos</div>
      </ng-template>

      <mat-card>
        <div class='content'>

          <mat-table class="table-doc" [dataSource]="_documentService.documentDataSource">

            <ng-container matColumnDef="icon">
              <mat-header-cell *matHeaderCellDef> </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <mat-icon style='font-size:1.2em; margin-top:10px;'>store_mall_directory</mat-icon>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="date">
              <mat-header-cell *matHeaderCellDef> Data </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{ element.date | date:'dd/MM/yyyy' }} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="filename">
              <mat-header-cell *matHeaderCellDef> Documento </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <div>
                  <div>
                    <a target="_blank" [href]='element.url' style='background-color: whitesmoke;'>
                      {{element.filename}}
                    </a>
                  </div>
                  <div style="margin-left: 20px;">
                    <i>{{element.folder_name}}</i>
                  </div>

                </div>


              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="vaccinated">
              <mat-header-cell *matHeaderCellDef> Vacina </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <span *ngIf="element.proofOfVaccine">
                  Sim
                </span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="approved">
              <mat-header-cell *matHeaderCellDef> Status </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <span *ngIf='element.approved'>
                  Aprovado
                </span>
                <span *ngIf='!element.approved'>
                  Aguardando
                </span>

              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="edit">
              <mat-header-cell *matHeaderCellDef>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <a mat-button (click)='openDocumentDialog(element)' style='background-color: whitesmoke;'>
                  <mat-icon class='icon-info' style='font-size:1.5em;'>
                    info_outline
                  </mat-icon>
                </a>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="delete">
              <mat-header-cell *matHeaderCellDef>
                <button mat-button (click)='openDocumentDialog(null)'>
                  <mat-icon class='icon-add'>add_circle_outline</mat-icon>
                </button>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <a mat-button (click)='deleteDocument(element)' style='background-color: whitesmoke;'>
                  <mat-icon class='icon-delete' style='font-size:1.5em;'>delete_outline
                  </mat-icon>
                </a>
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedDocumentColumns"></mat-header-row>

            <mat-row *matRowDef="let row; columns: displayedDocumentColumns;"></mat-row>

          </mat-table>

        </div>
      </mat-card>

    </mat-tab>

    <mat-tab *ngIf="isEdit">
      <ng-template mat-tab-label>
        <mat-icon class='tab-icon'>monetization_on</mat-icon>
        <div>Anuidades</div>
      </ng-template>

      <div style="margin: 10px; padding: 10px;">

        <div *ngIf="isAnnuityFree" style="margin: 30px; color: rgba(0,0,0,.6);">
          <b>Isento</b>
        </div>

        <div *ngIf="!isAnnuityFree">

          <div *ngIf="!annuitesDataSource">
            <div style="width: 100px; margin: auto;">
              <img src="assets/images/geral/spinner.gif" style="width: 100%">
            </div>
          </div>

          <div *ngIf="annuitesDataSource">

            <mat-card *ngIf="totalPlots === 0">
              Quite
            </mat-card>
            <mat-card *ngIf="totalPlots === 1">
              <div class="collect-wrapper">
                <div style="padding-top: 5px;">
                  {{totalPlots}} anuidade em aberto, débito = {{ totalDebit | currency:'BRL':'':'1.2-2' }}
                </div>

              </div>
            </mat-card>

            <mat-card *ngIf="totalPlots > 1" style="padding: 0 10px 0 10px; margin: 10px 0 10px 0;">
              <div class="collect-wrapper">
                <div style="padding-top: 7px;">
                  {{totalPlots}} anuidades em aberto, débito = {{ totalDebit | currency:'BRL':'':'1.2-2' }}
                </div>
              </div>
            </mat-card>

            <!--
            <mat-card *ngIf="nextAnnuity">

              <div style="display: flex; flex-direction: row;">
                <div style="width: 280px">
                 {{nextAnnuity.product_name}}
                </div>
                <div style="width: 100px">
                  {{nextAnnuity.date | date: 'dd/MM/yyyy' }}
                </div>
                <div style="width: 200px">
                  {{nextAnnuity.category_name}}
                </div>
                <div style="width: 80px">
                  {{nextAnnuity.origin}}
                </div>
                <div style="width: 100px">
                  {{nextAnnuity.type}}
                </div>
                <div style="width: 100px; text-align: right; justify-content: flex-end;">
                  {{nextAnnuity.value | currency:'BRL':'':'1.2-2' }}
                </div>
                <div style="width: 100px; text-align: right; justify-content: flex-end;">
                  {{nextAnnuity.total | currency:'BRL':'':'1.2-2' }}
                </div>
              </div>

            </mat-card>
-->
            <mat-table class="table-annuity" [dataSource]="annuitesDataSource" matSort>

              <ng-container matColumnDef="annuity">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Anuidade </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  {{ element.name }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="date">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Data </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <div *ngIf="element.order">
                    <span *ngIf="!element.order.datePayed">
                      {{ element.order.date._seconds*1000 | date: 'dd/MM/yyyy' }}
                    </span>
                    <span *ngIf="element.order.datePayed">
                      {{ element.order.datePayed | date: 'dd/MM/yyyy' }}
                    </span>
                  </div>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="category">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Categoria </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <span *ngIf="element.order">
                    {{ element.order.category_name }}
                  </span>
                  <span *ngIf="!element.order">
                    {{ element.price.category.name }}
                  </span>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="origin">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Origem </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <span *ngIf="element.order">
                    {{ element.order.origin }}
                  </span>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="type">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Tipo </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <span *ngIf="element.order">
                    {{ element.order.payment_type }}
                  </span>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="tid">
                <mat-header-cell *matHeaderCellDef mat-sort-header> TID </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <span *ngIf="element.order">
                    {{ element.order.tid }}
                  </span>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="value">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Valor </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <span *ngIf="element.order">
                    {{ element.order.value | currency:'BRL':'':'1.2-2' }}
                  </span>
                  <span *ngIf="!element.order" style="color:red;">
                    {{ element.price.value | currency:'BRL':'':'1.2-2' }}
                  </span>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="total">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Total </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <span *ngIf="element.order">
                    {{ element.order.total | currency:'BRL':'':'1.2-2' }}
                  </span>
                  <span *ngIf="!element.order" style="color:red;">
                    {{ element.price.value | currency:'BRL':'':'1.2-2' }}
                  </span>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="edit">
                <mat-header-cell *matHeaderCellDef>
                  <a mat-button (click)='refresAnnuities()' style='background-color: whitesmoke;'>
                    <mat-icon class='icon-done' style='font-size:1.5em;'>
                      refresh
                    </mat-icon>
                  </a>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <a mat-button *ngIf="!element.order" (click)='openPaymentDialog(element)'
                    style='background-color: whitesmoke;'>
                    <mat-icon class='icon-info' style='font-size:1.5em;'>
                      info_outline
                    </mat-icon>
                  </a>
                  <a mat-button *ngIf="element.order" (click)='openEditPaymentDialog(element)'
                    style='background-color: whitesmoke;'>
                    <mat-icon class='icon-add' style='font-size:1.5em;'>
                      info_outline
                    </mat-icon>
                  </a>

                </mat-cell>
              </ng-container>

              <mat-header-row class='mat-header-row' *matHeaderRowDef="displayedAnnuitesColumns">
              </mat-header-row>

              <mat-row *matRowDef="let row; columns: displayedAnnuitesColumns;">
              </mat-row>

            </mat-table>

          </div>

        </div>

      </div>

    </mat-tab>

    <mat-tab *ngIf="isEdit">
      <ng-template mat-tab-label>
        <mat-icon class='tab-icon'>sticky_note_2</mat-icon>
        <div>Inscrições</div>
      </ng-template>

      <mat-card>
        <mat-table class='table-orders' [dataSource]="_orderedService.ordersByMemberDataSource" matSort
          matSortActive="date" matSortDirection='desc'>

          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Nome </mat-header-cell>
            <mat-cell *matCellDef="let element">

              <div style='width: 100%; margin:10px; padding:20px 0 20px 0;'>

                <div class='order-item'>
                  <div class='label'>
                    Data:
                  </div>
                  <div class='value'>
                    <b *ngIf='element.order_date'>
                      {{ element.order_date.seconds*1000 | date:'dd/MM/yyyy' }}
                    </b>
                    <b *ngIf='!element.order_date'>
                      *
                    </b>
                  </div>
                  <div style="padding-top: 5px; margin-left: 10px; cursor: pointer;" (click)="changeOrderDate(element)">
                    <mat-icon class='icon-info'>
                      info_outline
                    </mat-icon>
                  </div>
                </div>

                <div class='order-item'>
                  <div class='label'>
                    Produto:
                  </div>
                  <div class='value'>
                    <b> {{ element.product_name }} </b>
                  </div>
                </div>

                <div class='order-item' *ngIf="element.topic_name">
                  <div class='label'>
                    -
                  </div>
                  <div class='value'>
                    <b> {{ element.topic_name }} </b>
                  </div>
                </div>

                <div class='order-item'>
                  <div class='label'>
                    Cliente:
                  </div>
                  <div class='value'>
                    {{ element.member_name }}
                  </div>
                </div>

                <div class='order-item'>
                  <div class='label'>
                    Categoria:
                  </div>
                  <div class='value'>
                    <span *ngIf='partnerText != "Não Sócio"'>
                      {{ partnerText }} -
                    </span>
                    <span>
                      {{ element.category_name }}
                    </span>
                  </div>
                </div>

                <div class='order-item' *ngIf='element.Tid'>
                  <div class='label'>
                    Transação:
                  </div>
                  <div class='value'>
                    {{ element.Tid }}
                  </div>
                </div>

                <div class='order-item'>
                  <div class='label'>
                    Tipo:
                  </div>
                  <div class='value'>
                    {{ element.payment_type_display }}
                  </div>
                </div>

                <div class='order-item'>
                  <div class='label'>
                    Valor Bruto:
                  </div>
                  <div class='value'>
                    {{ element.value | currency:'BRL':'':'1.2-2' }}
                  </div>
                </div>

                <div class='order-item' *ngIf='element.member_debit > 0'>
                  <div class='label'>
                    Débito:
                  </div>
                  <div class='value'>
                    {{ element.member_debit | currency:'BRL':'':'1.2-2' }}
                  </div>
                </div>

                <div class='order-item' *ngIf='element.discount > 0'>
                  <div class='label'>
                    Desconto:
                  </div>
                  <div class='value'>
                    {{ element.discount | currency:'BRL':'':'1.2-2' }}
                  </div>
                </div>


                <div class='order-item' *ngIf='element.tax > 0'>
                  <div class='label'>
                    Taxa:
                  </div>
                  <div class='value'>
                    {{ element.tax }}
                  </div>
                </div>

                <div class='order-item'>
                  <div class='label'>
                    Valor Líquido:
                  </div>
                  <div class='value'>
                    {{ element.valor_liquido | currency:'BRL':'':'1.2-2' }}
                  </div>
                </div>

                <div class='order-item'>
                  <div class='label'>
                    Origem:
                  </div>
                  <div class='value'>
                    {{ element.origin }}
                  </div>
                </div>

                <div class='order-item'>
                  <div class='label'>
                    Recibo:
                  </div>
                  <div class='value'>
                    <a target="_blank" [href]="element.receiptUrl">{{element.receiptUrl}}</a>
                  </div>
                </div>
                <div class='order-item' *ngIf="!element.receiptUrl">
                  <button mat-raised-button (click)='gerarRecibo(element)'>
                    gerar recibo
                  </button>
                </div>
              </div>

            </mat-cell>
          </ng-container>

          <mat-header-row class='mat-header-row' *matHeaderRowDef="displayedOrdersByMembrColumns">
          </mat-header-row>

          <mat-row *matRowDef="let row; columns: displayedOrdersByMembrColumns;">
          </mat-row>

        </mat-table>
      </mat-card>

    </mat-tab>

    <mat-tab *ngIf="isEdit">
      <ng-template mat-tab-label>
        <mat-icon class='tab-icon'>school</mat-icon>
        <div>Certificados</div>
      </ng-template>

      <mat-card>
        <mat-table class="table-certs" [dataSource]="enrolmentDataSource">

          <ng-container matColumnDef="event">
            <mat-header-cell *matHeaderCellDef> Evento </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <ul>
                <li *ngIf='element.event_name'>{{ element.event_name }}</li>
                <li *ngIf='element.activity_name'>{{ element.activity_name }}</li>
                <li *ngIf='element.topic_name'>{{ element.topic_name }}</li>
                <li *ngIf='element.type'>{{ element.type }}</li>
              </ul>

            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="request">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">

              <a mat-button matTooltip="Gerar certificado" *ngIf='!element.certificate_url'
                (click)='requestCertificate(element)' style='background-color: whitesmoke;'>
                <mat-icon class='icon-add' style='font-size:1.5em;'>
                  touch_app
                </mat-icon>
              </a>

              <div *ngIf='element.certificate_url == "gerando"'>
                <img style="width:30px;" src="assets/images/geral/spinner.gif">
              </div>

              <div *ngIf='element.certificate_url != "gerando"'>

                <div *ngIf="element.certificate_url" style='display: flex; flex-direction: row;'>

                  <div>
                    <a mat-button matTooltip="Visualizar" target='_blank' href={{element.certificate_url}}>
                      <mat-icon class='icon-add'>remove_red_eye</mat-icon>
                    </a>
                  </div>

                  <div>
                    <a mat-button matTooltip="Enviar por email" (click)='sendCertByEmail(element)'>
                      <mat-icon class='icon-add'>email</mat-icon>
                    </a>
                  </div>

                </div>

              </div>

            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="delete">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a mat-button (click)='deleteEnrollment(element)' style='background-color: whitesmoke;'>
                <mat-icon class='icon-delete' style='font-size:1.5em;'>delete_outline
                </mat-icon>
              </a>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedEnrolmentColumns"></mat-header-row>

          <mat-row *matRowDef="let row; columns: displayedEnrolmentColumns;"></mat-row>

        </mat-table>
      </mat-card>

    </mat-tab>

    <mat-tab *ngIf="isEdit">
      <ng-template mat-tab-label>
        <mat-icon class='tab-icon'>edit_calendar</mat-icon>
        <div>Agendas</div>
      </ng-template>

      <mat-card>
        <div class='tab-agenda' style='color:rgba(0,0,0,.7);'>

          <ul>
            <li *ngFor="let evt of _agendaService.arrayEvents" style='padding:7px;'>
              <b>{{ evt.name}}</b>
              <ul>
                <li *ngFor="let day of evt.days" style='padding:7px;'>
                  {{ day.date.seconds*1000 | date:'dd/MM/yyyy'}} - {{day.name}}
                  <ul>
                    <li *ngFor="let activity of day.activities" style='padding:7px;'>
                      {{activity.startTime}} - {{activity.name}}
                      <ul>
                        <li *ngFor="let topic of activity.topics" style='padding:7px;'>
                          {{topic.startTime}} - {{topic.name}}
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
              <hr>
            </li>

          </ul>

        </div>
      </mat-card>

    </mat-tab>

  </mat-tab-group>

</div>